document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const menu = document.querySelector('[data-mobile-menu]');
const openButton = document.querySelector('[data-menu-toggle]');
const closeButton = document.querySelector('[data-menu-close]');
let lastFocusedElement = null;
let closeTimer = null;

function getFocusableElements() {
  if (!menu) return [];
  return [...menu.querySelectorAll('a[href], button:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])')]
    .filter((element) => element.offsetParent !== null);
}

function setMenu(open) {
  if (!menu || !openButton) return;
  window.clearTimeout(closeTimer);

  if (open) {
    lastFocusedElement = document.activeElement;
    menu.hidden = false;
    // Force layout so the drawer transition starts from the closed position.
    void menu.offsetWidth;
    menu.classList.add('is-open');
    document.body.classList.add('menu-open');
    openButton.setAttribute('aria-expanded', 'true');
    window.setTimeout(() => closeButton?.focus(), 60);
  } else {
    menu.classList.remove('is-open');
    document.body.classList.remove('menu-open');
    openButton.setAttribute('aria-expanded', 'false');
    closeTimer = window.setTimeout(() => {
      menu.hidden = true;
      if (lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus();
    }, 280);
  }
}

openButton?.addEventListener('click', () => setMenu(true));
closeButton?.addEventListener('click', () => setMenu(false));
menu?.addEventListener('click', (event) => {
  if (event.target === menu) setMenu(false);
});
menu?.querySelectorAll('a[href]').forEach((link) => link.addEventListener('click', () => setMenu(false)));

document.addEventListener('keydown', (event) => {
  if (!menu || menu.hidden) return;
  if (event.key === 'Escape') {
    setMenu(false);
    return;
  }
  if (event.key !== 'Tab') return;

  const focusable = getFocusableElements();
  if (!focusable.length) return;
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
});

window.addEventListener('resize', () => {
  if (window.innerWidth > 1100 && menu && !menu.hidden) setMenu(false);
});

document.querySelectorAll('[data-before-after]').forEach((component) => {
  const range = component.querySelector('input[type="range"]');
  const update = () => component.style.setProperty('--position', `${range.value}%`);
  range?.addEventListener('input', update);
  update();
});

document.addEventListener('click', (event) => {
  const poster = event.target.closest('[data-measurement-video]');
  if (!poster) return;

  const embedUrl = poster.dataset.embedUrl;
  if (!embedUrl) return;

  const iframe = document.createElement('iframe');
  iframe.src = `${embedUrl}${embedUrl.includes('?') ? '&' : '?'}autoplay=1`;
  iframe.title = poster.getAttribute('aria-label') || document.title;
  iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  iframe.allowFullscreen = true;
  poster.replaceWith(iframe);
});

document.querySelectorAll('[data-variant-select]').forEach((select) => {
  select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const price = select.closest('[data-product-section]')?.querySelector('[data-product-price] span');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
  });
});

const observer = 'IntersectionObserver' in window
  ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .12 })
  : null;

document.querySelectorAll('.reveal').forEach((element) => observer ? observer.observe(element) : element.classList.add('is-visible'));
